import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { PEEKPASS_BRAND, PEEKPASS_DOMAIN, PEEKPASS_TAGLINE } from '../utils/peekPassBrand';

export interface HeaderProps {
  showBackButton?: boolean;
  onBack?: () => void;
  title?: string;
  className?: string;
  children?: React.ReactNode;
}

const Header: React.FC<HeaderProps> = ({
  showBackButton = false,
  onBack,
  title = PEEKPASS_BRAND,
  className = '',
  children
}) => {
  return (
    <header className={`sticky top-0 z-50 border-b border-white/10 bg-black ${className}`}>
      <div className="mx-auto flex w-full min-w-0 max-w-[1440px] items-center gap-1.5 px-2.5 py-2 min-[390px]:gap-2 min-[390px]:px-3 sm:gap-4 sm:px-6 sm:py-3 lg:px-8">
        {showBackButton && onBack ? (
          <button
            onClick={onBack}
            className="inline-flex h-9 shrink-0 touch-manipulation items-center gap-1 rounded-full border border-white/15 bg-white/5 px-2.5 text-[11px] font-semibold text-white transition hover:bg-white/10 min-[390px]:h-10 min-[390px]:gap-1.5 min-[390px]:px-3 min-[390px]:text-xs sm:h-11 sm:gap-2 sm:px-4 sm:text-sm"
          >
            <ArrowLeft className="h-4 w-4" />
            Atrás
          </button>
        ) : null}

        <div className="flex min-w-0 flex-1 flex-row items-center gap-1.5 min-[390px]:gap-2 sm:gap-4">
          <div className="flex h-10 w-[106px] max-w-full shrink-0 items-center justify-start overflow-hidden rounded-md bg-transparent min-[390px]:h-11 min-[390px]:w-[122px] sm:h-20 sm:w-[240px] sm:rounded-xl lg:w-[296px]">
            <img
              src="/peekpassclubverde_headerlogo.png"
              alt={PEEKPASS_BRAND}
              className="h-full w-full object-contain object-center"
            />
          </div>
          <div className="min-w-0 max-w-full flex-1 leading-none">
            <p className="truncate whitespace-nowrap text-[6px] font-semibold uppercase tracking-[0.14em] text-white/65 min-[390px]:text-[7px] min-[390px]:tracking-[0.17em] sm:text-[10px] sm:tracking-[0.34em]">
              {PEEKPASS_DOMAIN}
            </p>
            <h1 className="mt-0.5 truncate whitespace-nowrap text-[11px] font-black leading-tight tracking-[-0.025em] text-white min-[390px]:text-xs sm:mt-0 sm:text-2xl">
              {title}
            </h1>
            <p className="mt-0.5 truncate whitespace-nowrap text-[7px] leading-tight text-white/75 min-[390px]:text-[8px] sm:mt-0 sm:text-sm">
              {PEEKPASS_TAGLINE}
            </p>
          </div>
        </div>

        {children ? (
          <div className="ml-auto flex items-center gap-2 sm:gap-3">
            {children}
          </div>
        ) : null}
      </div>
    </header>
  );
};

export default Header;
